<template>
    <v-scale-transition>
        <div v-show="active">

            <v-card v-if="active" raised height="100" :color="active ? 'green darken-3' : ''">

                <v-container fluid class="pt-0 pb-0">
                    <v-row no-gutters>
                        <v-col cols="12">
                            <div class="d-flex flex-row pt-4 pb-2">
                                <v-icon class="pr-2" size="35px">mdi-filter-outline</v-icon>
                                <span class="display-1">
                            FILTERS
                        </span>
                            </div>
                        </v-col>
                    </v-row>

                    <v-row no-gutters>
                        <v-col cols="12">
                            <div class="d-flex flex-row">
                                <span>{{names}}</span>
                            </div>
                        </v-col>

                    </v-row>
                </v-container>

            </v-card>

        </div>
    </v-scale-transition>
</template>

<script>

    import {timeDisplay} from '../../../components/mixins/timeDisplayMixin';

    export default {

        mixins: [timeDisplay],

        props: {
            filter: {
                type: Object,
                required: true,
            }
        },

        computed: {
            active() {
                return this.filter.active === true ||
                    this.filter.excludeCategoriesActive === true ||
                    this.filter.projectFilterActive;
            },
            names() {
                let filters = [];
                if (this.filter.active === true) filters.push("Activity");
                if (this.filter.excludeCategoriesActive === true) filters.push('Categories');
                if (this.filter.projectFilterActive === true) filters.push('Project');

                return filters.join(', ');
            }
        },

        data() {
            return {
                activityFilterDialogModel: false,
                properties: {}
            }
        },
    }
</script>
